// Locales the Mayday front bundles. Anything else falls back to FALLBACK_LOCALE.
export const SUPPORTED_LOCALES = ['fr', 'en', 'de']
export const FALLBACK_LOCALE = 'fr'

// Maps navigator.language (e.g. "en-US", "de-DE", "fr-CH") to one of
// SUPPORTED_LOCALES. Unknown or undefined inputs collapse to FALLBACK_LOCALE.
export function detectLocale(rawLanguage) {
  if (!rawLanguage || typeof rawLanguage !== 'string') return FALLBACK_LOCALE

  const base = rawLanguage.toLowerCase().split('-')[0]
  return SUPPORTED_LOCALES.includes(base) ? base : FALLBACK_LOCALE
}

// Picks the first supported locale from a preference list (e.g.
// navigator.languages). Useful for multilingual users whose primary
// navigator.language is unsupported but a secondary preference is.
export function pickPreferredLocale(rawLanguages) {
  if (!rawLanguages || rawLanguages.length === 0) return FALLBACK_LOCALE

  for (const lang of rawLanguages) {
    if (typeof lang !== 'string') continue
    const base = lang.toLowerCase().split('-')[0]
    if (SUPPORTED_LOCALES.includes(base)) return base
  }
  return FALLBACK_LOCALE
}
